/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiReviewRequestEntityType } from './InternalApiReviewRequestEntityType';
import {
    InternalApiReviewRequestEntityTypeFromJSON,
    InternalApiReviewRequestEntityTypeFromJSONTyped,
    InternalApiReviewRequestEntityTypeToJSON,
    InternalApiReviewRequestEntityTypeToJSONTyped,
} from './InternalApiReviewRequestEntityType';
import type { InternalApiUserBasicDetails } from './InternalApiUserBasicDetails';
import {
    InternalApiUserBasicDetailsFromJSON,
    InternalApiUserBasicDetailsFromJSONTyped,
    InternalApiUserBasicDetailsToJSON,
    InternalApiUserBasicDetailsToJSONTyped,
} from './InternalApiUserBasicDetails';

/**
 * 
 * @export
 * @interface InternalApiReviewRequest
 */
export interface InternalApiReviewRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalApiReviewRequest
     */
    entityId: string;
    /**
     * 
     * @type {InternalApiReviewRequestEntityType}
     * @memberof InternalApiReviewRequest
     */
    entityType: InternalApiReviewRequestEntityType;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiReviewRequest
     */
    createdTime: Date;
    /**
     * 
     * @type {InternalApiUserBasicDetails}
     * @memberof InternalApiReviewRequest
     */
    createdBy: InternalApiUserBasicDetails;
    /**
     * Human readable name of the entity under review, when it can be resolved
     * @type {string}
     * @memberof InternalApiReviewRequest
     */
    label?: string;
    /**
     * Id of the entity the reviewed one belongs to, when it is not addressable on its own
     * @type {string}
     * @memberof InternalApiReviewRequest
     */
    parentEntityId?: string;
}



/**
 * Check if a given object implements the InternalApiReviewRequest interface.
 */
export function instanceOfInternalApiReviewRequest(value: object): value is InternalApiReviewRequest {
    if (!('entityId' in value) || value['entityId'] === undefined) return false;
    if (!('entityType' in value) || value['entityType'] === undefined) return false;
    if (!('createdTime' in value) || value['createdTime'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    return true;
}

export function InternalApiReviewRequestFromJSON(json: any): InternalApiReviewRequest {
    return InternalApiReviewRequestFromJSONTyped(json, false);
}

export function InternalApiReviewRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiReviewRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'entityId': json['entityId'],
        'entityType': InternalApiReviewRequestEntityTypeFromJSON(json['entityType']),
        'createdTime': (new Date(json['createdTime'])),
        'createdBy': InternalApiUserBasicDetailsFromJSON(json['createdBy']),
        'label': json['label'] == null ? undefined : json['label'],
        'parentEntityId': json['parentEntityId'] == null ? undefined : json['parentEntityId'],
    };
}

export function InternalApiReviewRequestToJSON(json: any): InternalApiReviewRequest {
    return InternalApiReviewRequestToJSONTyped(json, false);
}

export function InternalApiReviewRequestToJSONTyped(value?: InternalApiReviewRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entityId': value['entityId'],
        'entityType': InternalApiReviewRequestEntityTypeToJSON(value['entityType']),
        'createdTime': value['createdTime'].toISOString(),
        'createdBy': InternalApiUserBasicDetailsToJSON(value['createdBy']),
        'label': value['label'],
        'parentEntityId': value['parentEntityId'],
    };
}

